import React from 'react';

// Dark, gold-lit shell for login / join our team / password pages
export const BrandAuthLayout = ({ children, strapline, testId }) => (
  <div className="bd-auth flex items-center justify-center px-4 py-10" data-testid={testId}>
    <div className="relative z-10 w-full max-w-md bd-fade-up">
      <div className="mb-7 text-center">
        <img
          src="/butler-direct-logo-dark-background.png"
          alt="Butler Direct"
          className="mx-auto h-24 w-auto sm:h-28"
        />
        {strapline && (
          <p className="mt-4 text-xs font-semibold uppercase tracking-[0.3em] text-gold">
            {strapline}
          </p>
        )}
      </div>
      <div className="rounded-[14px] border border-gold/25 bg-[#1A1A1A]/95 p-6 shadow-[0_30px_80px_-40px_rgba(224,193,120,0.45)] backdrop-blur-sm sm:p-7">
        {children}
      </div>
      <p className="mt-6 text-center text-[11px] text-cream/45">
        Butler Direct · Premium butler and cocktail hosts
      </p>
    </div>
  </div>
);

export default BrandAuthLayout;
